/**
 * Latest recommended PSS (PSA Studio) version.
 * Update these values here whenever a new PSS build ships.
 */
const LATEST_PSS_VERSION = "1.1.3";
const LATEST_PSS_WINDOWS = "/downloads/PSA%20Studio%20Setup%201.1.3.rar?v=20260803-1";
const LATEST_PSS_MAC     = "/downloads/Party%20Sharing%20Studio-1.1.3.dmg?v=20260803-1";

export const getLatestPSSVersion = () =>
  Promise.resolve({
    data: {
      version: LATEST_PSS_VERSION,
      windows: LATEST_PSS_WINDOWS,
      mac: LATEST_PSS_MAC,
    },
  });
